import { useEffect } from 'react';
import { SimpleEvent } from '@passionware/simple-event';
import { useLocation } from 'react-router-dom';
import { RouteChangePayload } from 'v5/core/routing/routeChangeEvent';

export interface RouteChangeEmitterProps {
  routeChangeEvent: SimpleEvent<RouteChangePayload>;
}

export function RouteChangeEmitter({
  routeChangeEvent
}: RouteChangeEmitterProps) {
  const location = useLocation();

  useEffect(() => {
    routeChangeEvent.emit({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      fullPath: `${location.pathname}${location.search}${location.hash}`
    });
  }, [location.pathname, location.search, location.hash, routeChangeEvent]);

  return null;
}
